import { render, staticRenderFns } from "./Router.vue?vue&type=template&id=e82ec6f8&scoped=true&"
import script from "./Router.vue?vue&type=script&lang=js&"
export * from "./Router.vue?vue&type=script&lang=js&"
import style0 from "./Router.vue?vue&type=style&index=0&id=e82ec6f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ec6f8",
  null
  
)

export default component.exports